import {getBaseUrl, getQueryString} from "./common";
import Form from "./form";
import { trackLogin } from './analytics';

export class LoginForm {
    private form: HTMLFormElement;

    constructor(form: HTMLFormElement) {
        this.form = form;
    }

    processForm(event: Event): void {
        const queryParams = getQueryString();
        const url = queryParams == ''
            ? `${getBaseUrl()}login`
            : `${getBaseUrl()}login?${queryParams}`;
        
        // The login action answers a successful sign-in with a redirect (homepage / returnUrl), so the GA4 login
        // event is pushed from onRedirect, before the navigation; a 200 here would be unexpected.
        const form = new Form(url, this.form, null, (html: string) => {
            document.querySelector(
                '[data-component="LoginForm"]'
            ).innerHTML = html;
        }, () => trackLogin('password'));

        form.process(event);
    }
}
